<div id="absenteeism-chart">
    <h2 class="m-b-5" mat-dialog-title>{{title}}</h2>
    <div mat-dialog-content>
        <div *ngIf="isLoading" class="m-auto">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>
        <div *ngIf="!isLoading">
            <canvas baseChart [datasets]="absenteeismData" [labels]="chartService.monthLabels"
                [options]="chartOptions" legend="true"
                chartType="line">
            </canvas>
        </div>
    </div>
    <div class="text-a-r  m-t-10 m-b-10">
        <button mat-raised-button (click)="cancel()" color="warn">Cerrar</button>
    </div>
</div>